export class MyQaReviewConstants{
    public static readonly MyQaReviews_TopBarTitle: string = 'My QA Reviews';
    public static readonly MyQaReviews_CheckBoxHoverToolTip: string = 'By default only Document Versions with your pending QA review are displayed. Check this check box to display all the Document Version where you are assigned as Assigned QA, regardless of any other condition.';
    public static readonly MyQaReviews_ShowAllLabel: string = 'Show All';
    public static readonly MyQaReviews_ShowInformationIconCheckbox: boolean = true;
    public static readonly MyQaReviews_IsIncludeAll: boolean = false;
}